import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash'
import { usePipelineDataContextWithVariables } from '../provider/DDPDataProvider'
import { useFormattingContext } from '../../FormattingProvider/FormattingContext'

function DDPText ({ pipeline, variables, accessor, format, className, style, ...rest }) {
  const { data, isLoading, error } = usePipelineDataContextWithVariables(pipeline, variables)
  const { formatter } = useFormattingContext()

  const item = useMemo(() => {
    let value = get(data, accessor)
    if (value !== null && typeof value === 'object') {
      value = value.toString()
    }
    return format ? formatter(value, format) : value
  }, [data, accessor, format, formatter])

  if (isLoading || error) {
    return null
  }
  return (
    <div className={className} style={style} {...rest}>
      {item || null}
    </div>
  )
}

DDPText.propTypes = {
  /** The data pipeline to execute */
  pipeline: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),

  variables: PropTypes.any,

  /** Path to the item to display */
  accessor: PropTypes.string,

  format: PropTypes.string,

  className: PropTypes.string,

  style: PropTypes.object
}

export default DDPText
